import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ChatMessageDto } from 'src/app/data/models/dto/chat-message.dto';

@Component({
  selector: 'app-chat-item-archive',
  templateUrl: './chat-item-archive.component.html',
  styleUrls: ['./chat-item-archive.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatItemArchiveComponent implements OnInit {
  @Input() chatMessages: ChatMessageDto[] = [];
  @Input() showArchived: boolean = false;
  @Input() showActiveTickets: boolean = false;

  @Output() showArchivedChange = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  get hasArchivedMessages() {
    return this.chatMessages.some((chat) => {
      return chat.message.archived;
    });
  }

  get numArchivedMessagesUnread() {
    return this.chatMessages
      .filter((c) => c.message.archived)
      .map((cM) => cM.message.numMessagesUnread)
      .reduce((prev: number, curr: number): number => prev + curr, 0);
  }

  showArchivedRooms() {
    this.showArchivedChange.emit(true);
  }
}
